import {CustomerType} from "@/models/backend/CustomerModels";

export interface CreateListingRequest {
    id: string;
    templateId: string;
    countryIsoCode: string,
    type: string;
    quantity: number;
    price: number;
    shippingPrices: ShippingPriceSegment[];
    shippingAvailable: boolean;
    pickupAvailable: boolean;
    availableDate: string;
    endDate: string;
    postalCode: string;
    workingDays: string[];
    workingHours: {
        startTime: string,
        endTime: string
    };
    images: { filename: string; base64: string; contentType: string }[],
    featureValues: Array<{
        id: string;
        featureId: string;
        name: string;
        featureValues: string[];
    }>;
}

export enum ListingType {
    SALE = "SALE",
    OFFER = "OFFER",
    SERVICE = "SERVICE"
}

export interface ShippingPriceSegment {
    distance: number;
    price: number;
}

export interface UpdateListingRequest extends CreateListingRequest {}

export enum ListingStatus {
    DRAFT = 'DRAFT',
    PUBLISHED = 'PUBLISHED',
    CLOSED = 'CLOSED',
    SOLD = 'SOLD'
}

export interface UserListingResult {
    listing: Listing;
    totalBids: number;
    totalBidsPending: number;
}

export interface Listing {
    id: string;
    templateId: string;
    userId: string;
    isOwner: boolean;
    type: string;
    quantity: number;
    price: number;
    shippingPrices: ShippingPriceSegment[];
    distance: number;
    country: {
        isoCode: string;
        name: string;
    }
    shippingAvailable: boolean;
    pickupAvailable: boolean;
    availableDate: string;
    endDate: string;
    postalCode: string;
    workingDays: string[];
    workingHours: string;
    status: ListingStatus,
    featureValues: Array<{
        id: string;
        featureId: string;
        featureName: string,
        featureLabel: string,
        featureValues: string[];
    }>;

    images: string[];
    createdAt: string;
    updatedAt: string;
    customerType?: CustomerType;
    customerCertifications?: string[];
    customerName?: string;
    customerRating?: number;
}

export interface UserListingSearchCriteria {
    filters?: {
        type?: string;
        status?: ListingStatus[];
    }
    sort?: {
        sortBy?: string;
        sortOrder?: 'ASC' | 'DESC';
    };
    pagination?: {
        limit?: string;
        offset?: string;
    };
}


export interface UpdateListingStatusRequest {
    id: string;
    status: ListingStatus;
}


export interface ListingSearchCriteria {
    filters?: {
        type?: string;
        quantity?: string;
        price?: string;
        customerTypes?: CustomerType[];
        shippingPrice?: string;
        shippingAvailable?: string;
        pickupAvailable?: string;
        availableDate?: {
            from?: string;
            to?: string;
        };
        countryIsoCode?: string;
        location?: {
            postalCode?: string;
            rangeInKm?: string;
        };
        featureValueIds?: string[];
    };
    sort?: {
        sortBy?: string;
        sortOrder?: 'ASC' | 'DESC';
    };
    pagination?: {
        limit?: string;
        offset?: string;
    };
}

export interface SearchResult<T> {
    results: T[];
    total: number;
    limit: number;
    offset: number;
}
